import { Box, Card, CardActionArea, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { blue, grey } from '@mui/material/colors';
import React from 'react';
import useToggle from '../../../../hooks/useToggle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const useStyles = makeStyles({
  notationTypeCard: {
    border: `1px solid ${grey[500]}`,
    margin: '5px',
    '&:hover, &:focus': {
      border: `1px solid ${blue[600]}`,
    },
  },
  arrowUnselected: {
    backgroundColor: 'inherited',
  },
  arrowSelected: {
    backgroundColor: blue[600],
  },
});

interface INotationSelectionCard {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick: () => void;
}

const NotationSelectionCard = (props: INotationSelectionCard) => {
  const classes = useStyles();
  const [isHovered, toggleIsHovered] = useToggle();

  return (
    <Card
      className={classes.notationTypeCard}
      onMouseEnter={() => toggleIsHovered()}
      onMouseLeave={() => toggleIsHovered()}
    >
      <CardActionArea onClick={props.onClick}>
        <Box display="flex">
          <Box flexGrow={1} style={{ padding: '10px' }}>
            <Typography variant="h3" style={{ fontSize: '1.5rem' }}>
              <span style={{ marginRight: '5px' }}>{props.icon}</span>
              {props.title}
            </Typography>
            <Typography variant="body2">{props.children}</Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ padding: '0 5px' }}
            className={
              isHovered ? classes.arrowSelected : classes.arrowUnselected
            }
          >
            <Box>
              <ArrowForwardIosIcon fontSize="large" />
            </Box>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};
export default NotationSelectionCard;
